/**
 * ITB Attribution Capture - Frontend Script
 *
 * INSTALL: Add to theme.liquid before </head>
 * This script runs on the MAIN page (not in Shopify sandbox)
 * and captures attribution to FIRST-PARTY cookies.
 *
 * The web pixel (itb-pixel-v2.1.js) will read these cookies.
 */
(function(){
    'use strict';

    var DBG = false; // Set to true for debugging
    var log = function(){
        if(DBG) console.log.apply(console, ['[ITB_ATTR]'].concat(Array.prototype.slice.call(arguments)));
    };

    // ===========================================
    // CONFIG
    // ===========================================

    var COOKIE_DAYS = 90;  // 90 days attribution window
    var COOKIE_DAYS_CID = 365;  // 1 year for client ID

    // Attribution parameters to capture
    var PARAMS = [
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
        'gclid', 'gclsrc', 'gbraid', 'wbraid', 'dclid',
        'fbclid', 'fb_action_ids', 'fb_action_types', 'fb_source',
        'ttclid', 'msclkid', 'epik', 'twclid', 'sclid', 'ScCid', 'li_fat_id',
        'ref', 'source', 'campaign_id', 'ad_id', 'adset_id'
    ];

    // ===========================================
    // COOKIE HELPERS
    // ===========================================

    function getCookie(name){
        try{
            var v = ('; ' + document.cookie).split('; ' + name + '=');
            return v.length === 2 ? v.pop().split(';').shift() : '';
        }catch(e){ return ''; }
    }

    function setCookie(name, value, days){
        try{
            var expires = '';
            if(days){
                var d = new Date();
                d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = '; expires=' + d.toUTCString();
            }
            // First-party cookie - same domain, SameSite=Lax
            document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
            log('Cookie set:', name);
        }catch(e){}
    }

    function getCookieJson(name){
        try{
            var raw = getCookie(name);
            return raw ? JSON.parse(decodeURIComponent(raw)) : null;
        }catch(e){ return null; }
    }

    function setCookieJson(name, obj, days){
        try{
            var encoded = encodeURIComponent(JSON.stringify(obj));
            if(encoded.length > 3500){
                log('Cookie too large:', name, encoded.length);
                return false;
            }
            setCookie(name, encoded, days);
            return true;
        }catch(e){ return false; }
    }

    // ===========================================
    // CLIENT ID (persistent identifier)
    // ===========================================

    function ensureClientId(){
        var cid = getCookie('itb_cid');
        if(!cid){
            cid = (crypto.randomUUID ? crypto.randomUUID() :
                   Date.now().toString(16) + Math.random().toString(16).slice(2))
                  .replace(/-/g, '').slice(0, 32);
            setCookie('itb_cid', cid, COOKIE_DAYS_CID);
            log('New CID created:', cid);
        }
        return cid;
    }

    // ===========================================
    // ATTRIBUTION CAPTURE
    // ===========================================

    function detectSource(params){
        if(params.utm_source) return params.utm_source;
        if(params.gclid || params.gbraid || params.wbraid) return 'google_ads';
        if(params.fbclid) return 'facebook';
        if(params.ttclid) return 'tiktok';
        if(params.msclkid) return 'bing';
        if(params.epik) return 'pinterest';
        if(params.twclid) return 'twitter';
        if(params.sclid || params.ScCid) return 'snapchat';
        if(params.li_fat_id) return 'linkedin';
        return 'unknown';
    }

    function captureAttribution(){
        var urlParams = new URLSearchParams(window.location.search);
        var captured = {};
        var hasParams = false;

        PARAMS.forEach(function(key){
            var value = urlParams.get(key);
            if(value){
                captured[key] = value;
                hasParams = true;
            }
        });

        if(!hasParams){
            log('No attribution params in URL');
            return null;
        }

        // Add metadata
        captured._ts = Date.now();
        captured._lp = window.location.pathname;
        captured._ref = document.referrer || null;
        captured._src = detectSource(captured);

        log('Attribution captured:', captured._src);
        return captured;
    }

    function saveAttribution(){
        var current = captureAttribution();
        if(!current) return;

        // FIRST TOUCH - save only if not exists
        var ft = getCookieJson('itb_ft');
        if(!ft){
            setCookieJson('itb_ft', current, COOKIE_DAYS);
            log('First touch saved:', current._src);
        } else {
            log('First touch exists:', ft._src, '- keeping it');
        }

        // LAST TOUCH - always update
        setCookieJson('itb_lt', current, COOKIE_DAYS);
        log('Last touch updated:', current._src);

        // TOUCHPOINTS - append to journey (max 10)
        var touchpoints = getCookieJson('itb_tp') || [];

        // Compact touchpoint
        var tp = {
            t: current._ts,
            s: current._src,
            p: current._lp
        };

        // Add click IDs (truncated)
        if(current.gclid) tp.gc = current.gclid.slice(0, 50);
        if(current.fbclid) tp.fb = current.fbclid.slice(0, 50);
        if(current.ttclid) tp.tt = current.ttclid.slice(0, 50);
        if(current.msclkid) tp.ms = current.msclkid.slice(0, 50);

        // UTM params
        if(current.utm_source) tp.us = current.utm_source;
        if(current.utm_medium) tp.um = current.utm_medium;
        if(current.utm_campaign) tp.uc = current.utm_campaign;

        // Skip duplicate (same source within 5 min)
        var lastTp = touchpoints[touchpoints.length - 1];
        if(lastTp && lastTp.s === tp.s && (tp.t - lastTp.t) < 300000){
            log('Touchpoint skipped (duplicate)');
            return;
        }

        touchpoints.push(tp);
        if(touchpoints.length > 10) touchpoints = touchpoints.slice(-10);

        setCookieJson('itb_tp', touchpoints, COOKIE_DAYS);
        log('Touchpoint added, total:', touchpoints.length);
    }

    // ===========================================
    // SESSION REFERRER (for organic tracking)
    // ===========================================

    function captureSessionReferrer(){
        // Only capture if this is a new session (no existing session cookie)
        var sessionActive = getCookie('itb_sess');
        if(sessionActive){
            log('Session active, skip referrer capture');
            return;
        }

        // Set session marker (expires when browser closes)
        setCookie('itb_sess', '1', null);

        // Capture referrer if external
        var ref = document.referrer;
        if(ref){
            try{
                var refHost = new URL(ref).hostname;
                var curHost = window.location.hostname;

                // Only save if external referrer
                if(refHost !== curHost && !refHost.includes(curHost) && !curHost.includes(refHost)){
                    var sessionData = {
                        ref: ref,
                        refDomain: refHost,
                        landing: window.location.pathname + window.location.search,
                        ts: Date.now()
                    };
                    setCookieJson('itb_sr', sessionData, 1);  // 1 day
                    log('Session referrer saved:', refHost);
                }
            }catch(e){}
        }
    }

    // ===========================================
    // KLAVIYO FORM SUBMIT (email capture with attribution)
    // ===========================================

    function setupKlaviyoListener(){
        // Use new Klaviyo Forms API (klaviyoForms event)
        // See: https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript
        window.addEventListener('klaviyoForms', function(e){
            if(e.detail.type !== 'submit') return;

            var email = e.detail.metaData?.$email || e.detail.metaData?.email;
            if(!email) return;

            log('Klaviyo form submitted:', email);

            // Get current attribution (what brought them to the site)
            var ft = getCookieJson('itb_ft');
            var cid = getCookie('itb_cid');

            // TO JEST JEDYNY MOMENT, W KTORYM ANONIM STAJE SIE ZNANA OSOBA.
            // Do 12.09.2026 zabieralismy stad tylko nazwe zrodla (`ft_source`), a gubilismy
            // identyfikatory klikniecia. Skutek byl taki, ze sesja z reklamy wiedziala, SKAD
            // przyszla, ale nie wiedziala KIM jest, a zapis do newslettera odwrotnie — i nigdzie
            // nie dalo sie tych dwoch polowek skleic. Pomiar z 12.09: na 441 055 zdarzen z
            // `ft_fbclid` w 90 dniach zaledwie 1,9% mialo przy sobie mail, wiec dopasowanie
            // cross-device (reklama -> zapis na sample -> zakup z innej przegladarki) nie mialo
            // z czym pracowac. Dlatego zabieramy komplet: fbclid/gclid pierwszego kontaktu oraz
            // ciasteczka Mety _fbp/_fbc, ktore i tak sa w przegladarce.
            var fb = getCookieJson('itb_fb') || {};
            var emailData = {
                email: email,
                ts: Date.now(),
                ft_source: ft ? ft._src : null,
                ft_medium: ft ? ft.utm_medium : null,
                ft_campaign: ft ? ft.utm_campaign : null,
                ft_fbclid: ft ? (ft.fbclid || null) : null,
                ft_gclid: ft ? (ft.gclid || null) : null,
                fbp: getCookie('_fbp') || fb.fbp || null,
                fbc: getCookie('_fbc') || fb.fbc || null,
                form_id: e.detail.formId || null
            };

            // Hash liczymy ZANIM wyslemy — patrz hashEmail(). Wczesniej payload wychodzil
            // z hashem zastepczym, bo SHA-256 przez crypto.subtle jest asynchroniczne.
            hashEmail(email, function(hashed){
                emailData.hashed = hashed;
                setCookieJson('itb_email', emailData, COOKIE_DAYS);
                log('Email captured with attribution:', emailData.ft_source, 'fbclid:', !!emailData.ft_fbclid);
                sendEmailCaptureEvent(emailData, cid);
            });
        });
        log('Klaviyo form listener attached (klaviyoForms event)');
    }

    /**
     * SHA-256 maila — TEN SAM algorytm, ktorego uzywa backend, wiec po tej wartosci da sie
     * skleic zapis do newslettera z pozniejszym zakupem.
     *
     * Wynik oddajemy callbackiem, bo crypto.subtle.digest jest asynchroniczne. Poprzednia
     * wersja liczyla SHA-256 w tle, ale ZWRACALA synchronicznie hash zastepczy `simple_<hex>`
     * i to on szedl w zdarzeniu. Efekt: wszystkie 906 zdarzen `email_captured` z 90 dni mialo
     * hash, ktory nie pasowal do niczego w reszcie systemu — most miedzy mailem a zakupem nie
     * mial prawa zadzialac, nawet gdyby niesiono przy nim komplet identyfikatorow reklamowych.
     *
     * `simple_` zostaje wylacznie jako ostatnia deska ratunku (brak crypto.subtle, np. strona
     * serwowana po http), zeby zdarzenie w ogole wyszlo, a nie zniknelo po cichu.
     */
    function hashEmail(email, cb){
        var str = String(email).toLowerCase().trim();

        try {
            if(window.crypto && window.crypto.subtle){
                var data = new TextEncoder().encode(str);
                window.crypto.subtle.digest('SHA-256', data).then(function(buf){
                    var hex = Array.prototype.map.call(new Uint8Array(buf), function(b){
                        return ('0' + b.toString(16)).slice(-2);
                    }).join('');
                    cb(hex);
                })['catch'](function(){
                    log('SHA-256 failed, falling back');
                    cb(fallbackHash(str));
                });
                return;
            }
        } catch(e){
            log('crypto.subtle unavailable:', e);
        }

        cb(fallbackHash(str));
    }

    function fallbackHash(str){
        var hash = 0;
        for(var i = 0; i < str.length; i++){
            hash = ((hash << 5) - hash) + str.charCodeAt(i);
            hash = hash & hash;
        }

        return 'simple_' + Math.abs(hash).toString(16);
    }

    function sendEmailCaptureEvent(emailData, cid){
        // Send to ELK webhook endpoint.
        // Token JEST WYMAGANY: EventController odrzuca zadanie bez niego ("missing_token", 401).
        // Do 07.09.2026 skrypt go nie doklada, wiec UK nie zapisal ANI JEDNEGO zapisu do newslettera:
        // ~350 dziennie po stronie Klaviyo wobec zera w ELK. sendBeacon nie potrafi ustawic naglowkow,
        // wiec token idzie parametrem `k` — druga droga, ktora kontroler akceptuje.
        var elkUrl = window.ITB_ELK_URL || null;
        if(!elkUrl){
            log('ELK URL not configured, skipping event send');
            return;
        }
        var elkToken = window.ITB_ELK_TOKEN || null;
        if(elkToken){
            elkUrl += (elkUrl.indexOf('?') === -1 ? '?' : '&') + 'k=' + encodeURIComponent(elkToken);
        }

        var payload = {
            app_code: window.ITB_APP_CODE || 'unknown',
            event: {
                name: 'email_captured',
                v: 2.2,
                ts: emailData.ts,
                cid: cid,
                email: emailData.email,
                hashed_email: emailData.hashed,
                ft_source: emailData.ft_source,
                ft_medium: emailData.ft_medium,
                ft_campaign: emailData.ft_campaign,
                // Identyfikatory klikniecia i ciasteczka Mety — bez nich zapis do newslettera
                // jest nie do powiazania z reklama, ktora go przyniosla (patrz komentarz wyzej).
                ft_fbclid: emailData.ft_fbclid,
                ft_gclid: emailData.ft_gclid,
                fbp: emailData.fbp,
                fbc: emailData.fbc,
                form_id: emailData.form_id,
                capture_source: 'klaviyo_form'
            }
        };

        try {
            if(navigator.sendBeacon){
                navigator.sendBeacon(elkUrl, JSON.stringify(payload));
            } else {
                var xhr = new XMLHttpRequest();
                xhr.open('POST', elkUrl, true);
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.send(JSON.stringify(payload));
            }
            log('Email capture event sent to ELK');
        } catch(e){
            log('Failed to send email capture event:', e);
        }
    }

    // ===========================================
    // INIT
    // ===========================================

    function init(){
        log('Init...');

        // 1. Ensure client ID exists
        ensureClientId();

        // 2. Capture session referrer
        captureSessionReferrer();

        // 3. Capture attribution params
        saveAttribution();

        // 4. Setup Klaviyo form listener
        setupKlaviyoListener();

        log('Done. Cookies:', {
            cid: !!getCookie('itb_cid'),
            ft: !!getCookie('itb_ft'),
            lt: !!getCookie('itb_lt'),
            tp: !!getCookie('itb_tp'),
            sr: !!getCookie('itb_sr')
        });
    }

    // Run on DOMContentLoaded or immediately if already loaded
    if(document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
